
<div class="settings">
  <h4 class="secondary-font">
    Notification Settings
  </h4>

  <div class="labels">
    <div class="email">
      Email
    </div>
    <div>Mobile</div>
  </div>

  <div class="row">
    <div class="label">
      Notify me when a watchlist price alert is triggered
    </div>

    <checkbox
      id="notificationSettingsWatchlist"
      v-model="notificationSettings.watchlist"
      class="first"
      @input="updateNotificationSettings"
    />

    <checkbox
      id="notificationSettingsWatchlistMobile"
      v-model="notificationSettings.watchlistMobile"
      class="second"
      @input="updateNotificationSettings"
    />
  </div>

  <div class="row">
    <div class="label">
      Notify me when my collection value changes
    </div>

    <checkbox
      id="notificationSettingsCollection"
      v-model="notificationSettings.collection"
      class="first"
      @input="updateNotificationSettings"
    />

    <checkbox
      id="notificationSettingsCollectionMobile"
      v-model="notificationSettings.collectionMobile"
      class="second"
      @input="updateNotificationSettings"
    />
  </div>

  <div class="row">
    <div class="label">
      Notify me when one of my sales gets approved
    </div>

    <checkbox
      id="notificationSettingsSaleApproval"
      v-model="notificationSettings.saleApproval"
      class="first"
      @input="updateNotificationSettings"
    />

    <checkbox
      id="notificationSettingsSaleApprovalMobile"
      v-model="notificationSettings.saleApprovalMobile"
      class="second"
      @input="updateNotificationSettings"
    />
  </div>

  <div class="row">
    <div class="label">
      Notify me of important updates about Card Ladder
    </div>

    <checkbox
      id="notificationSettingsDailyUpdates"
      v-model="notificationSettings.dailyUpdates"
      class="first"
      @input="updateNotificationSettings"
    />

    <checkbox
      id="notificationSettingsDailyUpdatesMobile"
      v-model="notificationSettings.dailyUpdatesMobile"
      class="second"
      @input="updateNotificationSettings"
    />
  </div>
</div>
